<script lang="ts">
    import {getContext} from "svelte";
    import IconList from "../form/IconList.svelte";

    const { open } = getContext('simple-modal');
    export function showModel() {
        open(IconList, {});
    }
</script>
<slot>
    <button on:click={showModel}>アイコン一覧</button>
</slot>